import styled from 'styled-components'

import { space, SpaceProps } from '../../../themes'

export const Container = styled.div<SpaceProps>`
  ${space}
  width: 100%;
`
